import dayjs from 'dayjs';
// кодмод Vite (13.08.2026): инлайн-require → импорт
import customParseFormat from 'dayjs/plugin/customParseFormat';

export const checkToClearLocalStorage = () => {
  dayjs.extend(customParseFormat);

  Object.keys(localStorage).forEach(item => {
    if (item.includes('DeliveryClosing')) {
      parseLocalStorageKey({ split: ')today(', item });
    } else if (item.includes('DateTime')) {
      parseLocalStorageKey({ split: ')&&Id:', item });
    }
  });
};

export const parseLocalStorageKey = ({ split, item }) => {
  const dateNow = dayjs().unix();
  const season = 2592000 * 1000; // 1 month
  const closingDay = dayjs(item.split(split)[1], 'MM.DD.YYYY').unix();
  if (Math.abs(dateNow - closingDay) > season) {
    localStorage.removeItem(item);
  }
};
